import { AttachFile } from "@mui/icons-material";
import { Box, TextField, Typography } from "@mui/material";
import AdvancedInputField from "components/UI/AdvancedInputField/AdvancedInputField";
import React, { useRef, useState, useEffect } from "react";

const TextFieldWithUpload = ({
  submittedAnswer,
  isFrom,
  handleQuesAnswer,
  event,
  comment,
  question,
}) => {
  const [value, setValue] = useState("");
  const [file, setFile] = useState(null);
  const [commentBox, setCommentBox] = useState("");

  const inputRef = useRef(null);

  // Initialize state once
  useEffect(() => {
    if (submittedAnswer?.length > 0) {
      setValue(submittedAnswer?.[0]?.value || "");
      setFile(submittedAnswer?.[0]?.document || null);
      setCommentBox(submittedAnswer?.[0]?.comment || "");
    }
  }, []);

  // Single common handler
  const handleUpdate = ({ type, data }) => {
    if (type === "value") setValue(data);
    else if (type === "file") setFile(data);
    else if (type === "comment") setCommentBox(data);

    if (isFrom === "taskSection") {
      handleQuesAnswer({
        obj: {
          value: type === "value" ? data : value,
          document: type === "file" ? data : file,
          weightage: 1,
          comment: type === "comment" ? data : commentBox,
        },
        realQuestion: question,
      });
    }
  };

  const labelSize = { style: { fontSize: "14px" } };
  const placeholderSize = { inputProps: { sx: { fontSize: "14px" } } };

  return (
    <Box
      sx={{
        pointerEvents: isFrom === "publishedSurvey" ? "none" : "auto",
      }}
    >
      <TextField
        label="Type your text here"
        variant="outlined"
        value={value}
        onChange={(e) => handleUpdate({ type: "value", data: e.target.value })}
        fullWidth
        multiline
        minRows={4}
        margin="normal"
        style={{ pointerEvents: event }}
        InputLabelProps={labelSize}
        InputProps={placeholderSize}
      />

      <Box
        width="100%"
        style={{
          margin: "26px 5px",
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={() => inputRef.current?.click()}
      >
        <AttachFile
          style={{ backgroundColor: "#ced4da", padding: 4 }}
          color="disabled"
        />

        {submittedAnswer?.length > 0 &&
        (isFrom === "submissionSection" || isFrom === "approvalSection") ? (
          <Box border={1} borderRadius={4} p={1} borderColor="#cececece" ml={2}>
            {submittedAnswer?.[0]?.files?.[0]?.url ? (
              <a
                href={submittedAnswer?.[0]?.files?.[0]?.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#999" }}
              >
                {submittedAnswer?.[0]?.files?.[0]?.name}
              </a>
            ) : (
              <Typography variant="body2">
                No document has been uploaded
              </Typography>
            )}
          </Box>
        ) : (
          <>
            <input
              type="file"
              accept=".pdf"
              ref={inputRef}
              onChange={(e) =>
                handleUpdate({ type: "file", data: e.target.files[0] })
              }
              style={{ display: "none", pointerEvents: event }}
            />
            <Box
              style={{
                borderBottom: "2px solid #ced4da",
                marginLeft: 20,
                width: "100%",
                fontSize: "14px",
              }}
            >
              {file?.name || "Upload file"}
            </Box>
          </>
        )}
      </Box>

      {comment && (
        <Box style={{ pointerEvents: event, marginTop: 10 }}>
          <AdvancedInputField
            name="comment"
            data={commentBox}
            placeholder="Contributor's comment"
            handleChange={({ name, value }) =>
              handleUpdate({ type: name, data: value })
            }
          />
        </Box>
      )}
    </Box>
  );
};

export default TextFieldWithUpload;
